import { Box } from 'theme-ui';
import MuxVideoPlayer from '../MuxPlayer';

const CarouselVideoPlayer = ({ video }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        aspectRatio: '1/1',
        width: ['100%', 'min(100vh, 100vw)', 'min(50vw, 100vh)'],
        objectFit: 'cover',
        overflow: 'hidden',
      }}
    >
      <MuxVideoPlayer muxVideo={video} />
    </Box>
  );
};

export default CarouselVideoPlayer;
